import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import { computed, reactive, watch } from 'vue'
import { ProductPrice } from '@/types/api'
import { ChartData, ChartOptions } from 'chart.js'
import { Moment } from 'moment/moment'
import * as moment from 'moment'
import AppBarChart from "@/components/app/chart/AppBarChart.vue";
import { useStore } from "vuex";

interface Props {
  vendorCode: number,
  visible: boolean,
  height?: string
}

interface PricesData {
  lagerId: number,
  prices: ProductPrice[],
  begin: Moment,
  end: Moment,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SilpoProductPriceChart',
  props: {
    vendorCode: null,
    visible: { type: Boolean },
    height: { default: '250px' }
  },
  emits: ["pricesLoadingStart", "pricesLoadingFinish"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'pricesLoadingStart'): void,
  (e: 'pricesLoadingFinish'): void,
}), expose: any, slots: any, attrs: any }) {

const props = __props as { vendorCode: number, visible: boolean, height: string };

const store = useStore()





const lock = reactive<{ isLoading: boolean }>({ isLoading: false })

watch(() => props.visible, async (visible): Promise<void> => {
  if (visible) {
    emit('pricesLoadingStart')

    lock.isLoading = true
    try {
      await store.dispatch('shopping/silpo/productPrices/loadPricesForLager', props.vendorCode)
    } finally {
      lock.isLoading = false
      emit('pricesLoadingFinish')
    }
  }
})

const pricesData = computed<PricesData>((): PricesData => store.getters['shopping/silpo/productPrices/priceForLager'](props.vendorCode))

const pricesIsEmpty = computed<boolean>((): boolean => (pricesData.value.prices || []).length === 0)

const chartData = computed<ChartData>((): ChartData => {
  const dates = []

  let date = pricesData.value.begin.clone()

  // eslint-disable-next-line no-constant-condition
  while (true) {
    dates.push(date.format('YYYY-MM-DD'))
    date = date.add(1, 'days')
    if (date > pricesData.value.end) {
      break
    }
  }

  const data: { x: Date, y: number }[] = []
  dates.forEach((d) => {
    const priceData = pricesData.value.prices
        .filter((pd) => !!pd.price)
        .filter((pd) => moment(pd.date).format('YYYY-MM-DD') === d)[0]

    const dateParsed = moment(d)

    data.push({ x: dateParsed.toDate(), y: priceData?.price.amount || 0 })
  })

  return {
    datasets: [
      {
        label: ((): string => {
          const mainLabel = 'Prices'
          const unit = pricesData.value.prices[0]?.unit

          return unit
              ? `${mainLabel} (${unit})`
              : mainLabel
        })(),
        backgroundColor: '#f87979',
        data: data as any // eslint-disable-line @typescript-eslint/no-explicit-any
      }
    ]
  }
})

const chartOptions = computed<ChartOptions>((): ChartOptions => {
  return {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        type: 'time',
        time: {
          tooltipFormat: 'YYYY-MM-DD'
        }
      }
    }
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (props.visible && !_unref(pricesIsEmpty) && !lock.isLoading)
      ? (_openBlock(), _createBlock(AppBarChart, {
          key: 0,
          "chart-data": _unref(chartData),
          styles: { height: props.height || '250px' },
          options: _unref(chartOptions)
        }, null, 8, ["chart-data", "styles", "options"]))
      : _createCommentVNode("", true)
  ]))
}
}

})